<template>
  <div class="as-of-page">
    <el-alert type="info" show-icon :closable="false"
      title="PV总剩余=平台剩余+排队/分销/复购/特价剩余；排队收货&lt;2026-03-01；分销≥2026-04-06用distribution_flag；周薪PV=great_record type=1且amount&lt;1。" />

    <div class="margin-top-sm padding-sm bg-white radius filter-bar">
      <span class="filter-label">截止日</span>
      <el-date-picker v-model="statDate" type="date" value-format="yyyy-MM-dd" size="small"
        :picker-options="pickerOptions" />
      <span class="filter-label margin-left-sm">累计起始日</span>
      <el-date-picker v-model="cumulateStartDate" type="date" value-format="yyyy-MM-dd" placeholder="空=最早日起"
        size="small" clearable :picker-options="pickerOptions" />
      <el-button type="primary" size="small" class="margin-left-sm" :loading="loading" @click="loadData">查询</el-button>
      <span v-if="data && data.note" class="hint-text margin-left-sm">{{ data.note }}</span>
    </div>

    <div v-if="data && grand" class="margin-top-sm">
      <div class="section-title">总剩余（截止日）</div>
      <div class="stat-grid-2 margin-top-sm">
        <div class="stat-card highlight">
          <div class="stat-label">PV 总剩余</div>
          <div class="stat-value">{{ fmt(grand.pvRemainTotal) }}</div>
          <div class="stat-sub">产生 {{ fmt(grand.pvProducedTotal) }} · 消耗 {{ fmt(grand.pvConsumedTotal) }}</div>
        </div>
        <div class="stat-card highlight-green">
          <div class="stat-label">绿豆 总剩余（用户持有）</div>
          <div class="stat-value">{{ fmt(grand.mungBeanRemainTotal) }}</div>
          <div class="stat-sub">发放 {{ fmt(grand.mungBeanConsumedTotal) }} · 支出 {{ fmt(grand.mungBeanSpentTotal) }}</div>
        </div>
      </div>

      <div class="section-title margin-top-md">分项台账（每项产生 / 消耗 / 剩余）</div>
      <el-table :data="ledger" size="small" border stripe class="margin-top-sm" :row-class-name="ledgerRowClass"
        show-summary :summary-method="ledgerSummary">
        <el-table-column prop="sectorName" label="板块" width="130" fixed />
        <el-table-column label="PV（平台=流水表；订单板块=收货日）" align="center">
          <el-table-column prop="pvProduced" label="产生" width="110" />
          <el-table-column prop="pvConsumed" label="消耗" width="110" />
          <el-table-column prop="pvRemain" label="剩余" width="100">
            <template slot-scope="scope">
              <b :class="pvRemainClass(scope.row.pvRemain)">{{ fmt(scope.row.pvRemain) }}</b>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="绿豆" align="center">
          <el-table-column prop="mungBeanConsumed" label="消耗(耗PV发放)" width="120" />
          <el-table-column prop="mungBeanSpent" label="支出(用豆等)" width="110" />
          <el-table-column prop="mungBeanRemain" label="净额(产生−消耗)" width="120" />
        </el-table-column>
        <el-table-column prop="note" label="说明" min-width="220" show-overflow-tooltip />
      </el-table>

      <el-collapse class="margin-top-md">
        <el-collapse-item title="展开：平台/积分时点余额、流水大类明细" name="detail">
          <div class="stat-grid-4 margin-top-sm">
            <div class="stat-card"><div class="stat-label">平台历史总PV</div><div class="stat-value sm">{{ fmt(data.platformHisTotalPv) }}</div></div>
            <div class="stat-card"><div class="stat-label">平台剩余PV</div><div class="stat-value sm">{{ fmt(data.platformSurplusPv || data.platformEndPv) }}</div></div>
            <div class="stat-card"><div class="stat-label">平台期末PV(流水)</div><div class="stat-value sm">{{ fmt(data.platformEndPv) }}</div></div>
            <div class="stat-card"><div class="stat-label">特价池余额(当前)</div><div class="stat-value sm">{{ fmt(specialPoolRemain) }}</div></div>
            <div class="stat-card"><div class="stat-label">绿豆期末(计算)</div><div class="stat-value sm">{{ fmt(data.mungBeanEndBalance) }}</div></div>
            <div class="stat-card"><div class="stat-label">积分期末</div><div class="stat-value sm">{{ fmt(data.pointsEndBalance) }}</div></div>
          </div>
          <el-table :data="data.mungBeanCategoryCumulative" size="mini" border class="margin-top-sm" max-height="320">
            <el-table-column prop="categoryName" label="绿豆大类" />
            <el-table-column prop="inQty" label="产生" width="100" />
            <el-table-column prop="outQty" label="消耗" width="100" />
            <el-table-column prop="netQty" label="净额" width="100" />
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
import { QueryFinanceAsOfStat } from '@/api'

function yesterdayStr() {
  const d = new Date()
  d.setDate(d.getDate() - 1)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

function n(v) {
  const x = Number(v)
  return isNaN(x) ? 0 : x
}

export default {
  name: 'FinanceAsOfStatPanel',
  data() {
    return {
      loading: false,
      statDate: yesterdayStr(),
      cumulateStartDate: '2025-08-01',
      data: null,
      pickerOptions: { disabledDate: (t) => t.getTime() > Date.now() },
    }
  },
  computed: {
    grand() {
      return this.data && this.data.grandTotal
    },
    ledger() {
      return (this.data && this.data.sectorLedger) || []
    },
    specialPoolRemain() {
      const row = this.ledger.find(r => r.sectorCode === 'SPECIAL')
      return row ? row.pvRemain : 0
    },
  },
  created() {
    this.loadData()
  },
  methods: {
    fmt(v) {
      if (v === undefined || v === null || v === '') return '-'
      return String(v)
    },
    pvRemainClass(v) {
      return n(v) > 0 ? 'remain-pos' : ''
    },
    ledgerRowClass({ row }) {
      return n(row.pvRemain) > 0 || n(row.mungBeanRemain) !== 0 ? '' : 'row-dim'
    },
    sumLedgerField(prop) {
      return this.ledger.reduce((s, r) => s + n(r[prop]), 0)
    },
    ledgerSummary(param) {
      const { columns } = param
      const g = this.grand || {}
      const sums = []
      columns.forEach((col, idx) => {
        if (idx === 0) {
          sums[idx] = '合计'
          return
        }
        const p = col.property
        if (p === 'pvProduced') sums[idx] = this.fmt(g.pvProducedTotal)
        else if (p === 'pvConsumed') sums[idx] = this.fmt(g.pvConsumedTotal)
        else if (p === 'pvRemain') sums[idx] = this.fmt(g.pvRemainTotal)
        else if (p === 'mungBeanConsumed') sums[idx] = this.fmt(g.mungBeanConsumedTotal)
        else if (p === 'mungBeanSpent') sums[idx] = this.fmt(g.mungBeanSpentTotal)
        else if (p === 'mungBeanRemain') sums[idx] = this.fmt(this.sumLedgerField('mungBeanRemain'))
        else sums[idx] = ''
      })
      return sums
    },
    async loadData() {
      if (!this.statDate) return this.$message.warning('请选择截止日')
      this.loading = true
      try {
        const payload = { statDate: this.statDate }
        if (this.cumulateStartDate) payload.cumulateStartDate = this.cumulateStartDate
        this.data = await QueryFinanceAsOfStat(payload)
      } catch (e) {
        this.$message.error((e && e.message) || '查询失败')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style scoped>
.filter-bar { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.filter-label { color: #606266; font-size: 13px; }
.hint-text { color: #909399; font-size: 12px; }
.section-title { font-size: 15px; font-weight: 600; color: #303133; }
.stat-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.stat-grid-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; }
.stat-card { padding: 14px; background: #fff; border: 1px solid #ebeef5; border-radius: 4px; }
.stat-card.highlight { border-color: #409eff; background: #ecf5ff; }
.stat-card.highlight-green { border-color: #67c23a; background: #f0f9eb; }
.stat-label { font-size: 12px; color: #909399; }
.stat-value { font-size: 22px; font-weight: 700; color: #303133; margin-top: 6px; }
.stat-value.sm { font-size: 16px; }
.stat-sub { font-size: 11px; color: #909399; margin-top: 6px; }
.remain-pos { color: #e6a23c; }
.as-of-page >>> .row-dim td { color: #c0c4cc; }
</style>
